import Vue from 'vue'
import 'normalize.css'
import './common/main.css'
import './common/reportable.scss'
import './plugins/axios'
import Message from 'vue-m-message'
import '@vant/touch-emulator'
// import { Dialog, Notify, Toast } from 'vant'
import Vant from 'vant'
import 'vant/lib/index.css'
import './common/jsbridge'
import './common/umeng'
import './common/tracking'
import './common/util'
import './common/print'
import App from './App.vue'
import router from './router'
import { ROUTE_TYPE_MAP } from './common/routeTypeMap'
import { install } from 'vs-tree'
import 'vs-tree/dist/vs-tree.css'
import VueVirtualScroller from 'vue-virtual-scroller'
import "vue-virtual-scroller/dist/vue-virtual-scroller.css"

// 构建反向映射：路由path → type key
// ROUTE_TYPE_MAP 的 value 是 './staff' 这样的相对路径，统一转为 '/staff' 与 to.path 匹配
var pathToTypeMap = {};
Object.keys(ROUTE_TYPE_MAP).forEach(function(key) {
    var normalizedPath = '/' + ROUTE_TYPE_MAP[key].replace(/^\.\//, '');
    pathToTypeMap[normalizedPath] = key;
});

// 不需要鉴权拦截的路由白名单
var authWhiteList = ['/auth-middleware', '/authorization', '/land-login', '/land-home', '/download', '/'];

/**
 * 判断是否在飞书客户端环境中
 * h5sdk 和 tt 是飞书JSSDK注入的全局变量，仅在飞书客户端内可用
 */
function isInFeishuEnv() {
    return !!(window.h5sdk && window.tt);
}

router.beforeEach((to, from, next) => {
    /* 路由发生变化修改页面title */
    if (to.meta && to.meta.title) {
        document.title = to.meta.title;
    } else {
        document.title = '智慧产业链';
    }

    /*
     * 飞书应用内全局鉴权拦截：
     * 飞书工作台分享的URL链接会直接打开业务路由，跳过了 AuthMiddleware 的鉴权流程。
     * 如果当前在飞书客户端内、目标路由是受保护的业务路由、且未登录（无token），
     * 则重定向到鉴权中间页完成飞书免密登录。
     */
    var token = window.localStorage.getItem('token');
    var isProtectedRoute = !!pathToTypeMap[to.path];
    var isWhiteListed = authWhiteList.indexOf(to.path) !== -1 || to.path === '/auth-middleware';

    if (isInFeishuEnv() && isProtectedRoute && !isWhiteListed && !token && !query.isRedirect) {
        var typeKey = pathToTypeMap[to.path];
        // 将原始目标路由的query参数保存，鉴权完成后可以恢复
        var redirectQuery = { type: typeKey };
        // 携带额外的业务query参数（如 deviceCode、saleOrderNo 等）
        if (to.query) {
            Object.keys(to.query).forEach(function(k) {
                redirectQuery[k] = to.query[k];
            });
        }
        next({ path: '/auth-middleware', query: redirectQuery });
        return;
    }

    next();
});
Vue.use(VueVirtualScroller);
Vue.use(Message);
Vue.$message = Message;
Vue.use(install);
// Vue.use(Dialog, Notify, Toast);
Vue.use(Vant);

Vue.config.productionTip = false;
Vue.filter('toThousands', function(value) {
    return Vue.$util.toThousands(value);
});
Vue.filter('formatDate', function(value, fmt, forEng) {
    if(!value){
        return '--';
    }
    return Vue.$util.formatDate(value, fmt||'yyyy-MM-dd', forEng);
});
Vue.filter('emptyText', function(value) {
  if(typeof(value) == 'number' || typeof(value) == 'string') {
    return value;
  } else {
    return '--';
  }
});
Vue.directive('decimal', {
  bind(el, binding) {
    const decimalPlaces = binding.value || 3; // 默认限制 3 位小数

    el.addEventListener('input', function (e) {
      let val = e.target.value
        .replace(/[^0-9.]/g, '')
        .replace(/\.{2,}/g, '.');
      val = val.replace(/(\..*)\./g, '$1'); // 确保只有一个点号

      const parts = val.split('.');
      if (parts.length > 1) {
        parts[1] = parts[1].slice(0, decimalPlaces); // 限制小数位数
        val = parts.join('.');
      }
      if (val.startsWith('.')) {
        val = '0' + val;
      }

      e.target.value = val;
      // e.target.dispatchEvent(new Event("input")); 
    });
  }
});
new Vue({
  router,
  render: h => h(App)
}).$mount('#app');

//软键盘遮挡输入框的问题
if(navigator.userAgent.indexOf('_demeter/') != -1) {//flutter_webview_plugin加载的
  if(!/(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent)) {//ios没问题
    document.addEventListener('focus', (event) => {
      let target = event.target;
      if((target.nodeName.toLowerCase()=='input' && target.getAttribute('type')!='radio' && target.getAttribute('type')!='checkbox') || target.nodeName.toLowerCase() == 'textarea') {
        if(!target.getAttribute('readonly') && !target.getAttribute('disabled')) {
          setTimeout(() => {
            target.scrollIntoView();
          }, 200);
        }
      }
    }, true);
  }
}
